import {NgModule} from '@angular/core';
import {BurgerMenuComponent} from "./header/burger-menu/burger-menu.component";
import {NgbAccordionBody, NgbAccordionButton, NgbAccordionCollapse, NgbAccordionDirective, NgbAccordionHeader, NgbAccordionItem, NgbModal, NgbModalConfig} from "@ng-bootstrap/ng-bootstrap";
import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {AuthInterceptor} from "./interceptors/auth.interceptor";
import {DateAdapter, MAT_DATE_LOCALE} from "@angular/material/core";
import {DateFnsAdapter} from "@angular/material-date-fns-adapter";
import {es} from "date-fns/locale";
import {CommonModule, DatePipe} from "@angular/common";
import {FooterComponent} from "./footer/footer.component";
import {RouterLink} from "@angular/router";
import {ReactiveFormsModule} from "@angular/forms";
import {FooterMenuComponent} from "./footer/footer-menu/footer-menu.component";
import {FooterNewsletterComponent} from "./footer/footer-newsletter/footer-newsletter.component";
import { TranslocoModule } from '@jsverse/transloco';
import { MatDialogModule } from '@angular/material/dialog';
import { ModalComponent } from './lib/modal/modal.component';
import { NotFoundPageComponent } from './not-found-page/not-found-page.component';
import { FaqsComponent } from './faqs/faqs.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ContactComponent } from './contact/contact.component';
import { SnnAndInitiativesComponent } from './snn-and-initiatives/snn-and-initiatives.component';
import { SocialNetworksComponent } from './snn-and-initiatives/social-networks/social-networks.component';
import { InitiativesComponent } from './snn-and-initiatives/initiatives/initiatives.component';
import { BannerModalityComparatorComponent } from './banner-modalitycomparator/banner-modalitycomparator.component';
import { GtmComponent } from './gtm/gtm.component';

@NgModule({
  declarations: [
    FooterComponent,
    FooterMenuComponent,
    FooterNewsletterComponent,
    ModalComponent,
    NotFoundPageComponent,
    NotFoundPageComponent,
    FaqsComponent,
    ContactComponent,
    SnnAndInitiativesComponent,
    SocialNetworksComponent,
    InitiativesComponent,
    BannerModalityComparatorComponent,
    GtmComponent
  ],
  imports: [
    CommonModule,
    RouterLink,
    ReactiveFormsModule,
    TranslocoModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    NgbAccordionDirective,
    NgbAccordionItem,
    NgbAccordionHeader,
    NgbAccordionButton,
    NgbAccordionCollapse,
    NgbAccordionBody,
],
  providers: [
    NgbModalConfig,
    NgbModal,
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    {provide: DateAdapter, useClass: DateFnsAdapter},
    {provide: MAT_DATE_LOCALE, useValue: es},
    DatePipe
  ],
  exports: [
    FooterComponent,
    FaqsComponent,
    ContactComponent,
    SnnAndInitiativesComponent,
    SocialNetworksComponent,
    InitiativesComponent,
    BannerModalityComparatorComponent,
    GtmComponent
  ],

})
export class SharedModule {
}
